import {$CC, AFRICA_COUNTRIES, ALL_COUNTRIES, MapDifficultyLevel} from "../types";

// function print() {
//   const codes: string[] = []
//   for (const name of [
// "Algeria","Angola","Benin","Botswana","Burkina Faso","Burundi","Cameroon","Central African Republic","Chad", "Cote d'Ivoire","Democratic Republic of the Congo","Djibouti","Egypt","Equatorial Guinea","Eritrea","Ethiopia","Gabon","Gambia","Ghana","Guinea", "Guinea-Bissau","Kenya","Lesotho","Liberia","Libya","Madagascar","Malawi","Mali","Mauritania","Morocco","Mozambique","Namibia","Niger","Nigeria","Republic of the Congo","Rwanda","Senegal","Sierra Leone","Somalia","South Africa","Sudan","Tanzania","Togo","Tunisia","Uganda","Zambia", "Zimbabwe"
//   ]) {
//     console.log(name);
//     const country = ALL_COUNTRIES.find(c => c.name === name);
//     codes.push(`$CC("${country.cc}")`);
//   }
//   console.log(codes.join(", "));
// }
// print();
export class AfricaDifficultyLevel extends MapDifficultyLevel {

  static readonly VALUES = new Array<AfricaDifficultyLevel>(1);
  static readonly MEDIUM = AfricaDifficultyLevel.VALUES[0] = new AfricaDifficultyLevel("medium", "Medium", "Medium desc", AFRICA_COUNTRIES);
}